module.exports = __webpack_public_path__ + "static/media/icon-lms.bf90550a.svg";